import React, { useState } from 'react'
import Affix from './Affix'
import styles from './Sidebar.scss'
import PropTypes from 'prop-types'
import { Pulldown } from './icons'
import classNames from 'classnames'

const Sidebar = ({ offset, isOpen, children, hover, onClick }) => (
  <Affix 
    offset={offset} 
    position="absolute"
    onClick={onClick}
    className={classNames({
      [styles.sideBarOpen]: isOpen,
      [styles.sideBar]: !isOpen,
      [styles.sideBarHovered]: hover
    })}>
    <div className={styles.naviBar}>{children}</div>
  </Affix>
)

Sidebar.Item = ({ as, children, icon, rightIcon, className, ...rest }) => {
  const As = as
  const Icon = icon
  const RightIcon = rightIcon
  return (
    <div className={styles.naviItemWrap}>
      <As {...rest} className={classNames(rightIcon ? styles.naviItemRightIcon : styles.naviItem, className)}>
        <Icon size={20} />
        {children}
        {rightIcon && (
          <div className={styles.naviItemRightIconWrap}>
            <RightIcon size={16} />
          </div>
        )}
      </As>
    </div>
  )
}

Sidebar.Menu = ({ children, icon, title, ...rest }) => {
  const [isOpenList, setIsOpenList] = useState(false)
  const Icon = icon
  return (
    <div className={isOpenList ? styles.naviItemWrapOpened : styles.naviItemWrap}>
      <div {...rest} className={isOpenList ? styles.naviMenuOpened : styles.naviMenu} >
        <div className={styles.naviMenuClickArea} onClick={() => {setIsOpenList(!isOpenList)}}>
          <Icon size={20} />
          {title}
          <div className={styles.naviMenuPulldown}>
            <Pulldown size={12} transform={isOpenList ? 'rotate(180)' : 'rotate(0)'} />
          </div>
        </div>
        {isOpenList && children }
      </div>
    </div>
  )
}

Sidebar.MenuItem = ({ as, children, className, ...rest }) => {
  const As = as
  return (
    <div className={styles.naviItemWrap}>
      <As {...rest} className={classNames(styles.naviMenuItem, className)}>
        {children}
      </As>
    </div>
  )
}

Sidebar.propTypes = {
  offset: PropTypes.number,
  isOpen: PropTypes.bool
}

Sidebar.Item.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}

Sidebar.Menu.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}

Sidebar.defaultProps = {
  offset: 0,
  isOpen: false
}

Sidebar.Item.defaultProps = {
  as: 'div'
}

Sidebar.MenuItem.defaultProps = {
  as: 'div'
}

Sidebar.Item.displayName = 'Sidebar.Item'

Sidebar.Menu.displayName = 'Sidebar.Menu'

Sidebar.MenuItem.displayName = 'Sidebar.MenuItem'

export default Sidebar
